module.exports = __webpack_public_path__ + "static/media/r_sairam.a1c0ca15.jpg";